export const MASTHEAD_EVENTS = Object.freeze({
  changeTab: 'cityListingMasthead:changeTab'
});

export const dispatchChangeTab = (tab: string) => {
  document.dispatchEvent(
    new CustomEvent(MASTHEAD_EVENTS.changeTab, {
      bubbles: true,
      detail: { tab }
    })
  );
};
